<template>
    <div id="new-client">
        <div class="wrap btn-position-wrap">
            <div class="client-box">
                <section class="global-section">
                    <div class="row">
                        <div class="col-3">
                            <h2 class="section-title">Info</h2>
                            <p>Required fields are marked with *</p>
                            <p>All open user forms must be completed.</p>
                        </div>
                        <div class="col-9">
                            <div class="row">
                                <p v-if="recordUpdateSucc" style="    color: red;    position: absolute;    float: right;    right: 6%;">Please Fill Required fields</p>
                                <div class="col-5">
                                    <div class="line-item">
                                        <md-field class="md-block bigger-field without-line" md-no-float>
                                            <md-input v-model="newClient.companyName" placeholder="Name *"></md-input>
                                        </md-field>
                                        <div class="new-client-error" v-if="validationErrors['newClient.companyName']">{{ validationErrors['newClient.companyName'][0] }}</div>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input type="tel" v-model="newClient.phoneNumber" placeholder="Phone *"></md-input>
                                        </md-field>
                                        <div class="new-client-error" v-if="validationErrors['newClient.phoneNumber']">{{ validationErrors['newClient.phoneNumber'][0] }}</div>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.website" placeholder="Website (Example: https://example.io)"></md-input>
                                        </md-field>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.country" placeholder="Country"></md-input>
                                        </md-field>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.stateProvince" placeholder="State/Province"></md-input>
                                        </md-field>
                                    </div>
                                    <div class="line-item">
                                        <div class="left-item">
                                            <md-switch v-model="newClient.isAnalytics" class="md-primary">
                                                Analytics
                                            </md-switch>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.address" placeholder="Address *" @blur="clientTouchHanlder('address')"></md-input>
                                        </md-field>
                                        <div class="new-client-error" v-if="validationErrors['newClient.address']">{{ validationErrors['newClient.address'][0] }}</div>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-textarea v-model="newClient.description" placeholder="Description"></md-textarea>
                                        </md-field>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.city" placeholder="City"></md-input>
                                        </md-field>
                                    </div>
                                    <div class="line-item">
                                        <md-field class="md-block">
                                            <md-input v-model="newClient.zipPostalCode" placeholder="Zip/Postal Code" @blur="clientTouchHanlder('zipPostalCode')" required></md-input>
                                        </md-field>
                                        <div class="new-client-error" v-if="$v.newClient.zipPostalCode.$error">Please provide an zip/postal code.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- CONTACTS SECTION -->
                <section class="global-section" v-if="detailsAreVisible">
                    <div class="row" v-if="showContact">
                        <p v-if="recordUpdateSucc" style="    color: red;    position: absolute;    float: right;    right: 6%;">Please Fill Required fields</p>
                        <p v-if="recordUpdateSuccs" class="recordalert">Record updated successfully!</p>
                        <div class="col-12 form-error" v-if="contactFormError">{{ contactFormError }}</div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <h2 class="section-title">Contacts</h2>
                            <p>Required fields are marked with *</p>
                        </div>
                        <div class="col-9">
                            <div class="dynamic-contacts">
                                <div class="row" v-for="(contact, index) in newClientContacts">
                                    <div class="col-12">
                                        <div class="avatar-block">
                                            <div class="row">
                                                <div class="col-5">
                                                    <div class="avatar upload s-48 gray">
                                                        <md-icon class="icon icon-person"></md-icon>
                                                    </div>
                                                    <div class="client-name-box">
                                                        <div class="line-item">
                                                            <md-field class="md-block client-name without-line" md-no-float>
                                                                <md-input type="email" v-model="contact.email" placeholder="Email *" @blur="contactTouchHanlder(index, 'email')"></md-input>
                                                            </md-field>
                                                            <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.email']"><span>{{ validationErrors['newContacts.' + index + '.email'][0] }}</span></div>
                                                        </div>
                                                        <div class="line-item">
                                                            <md-field class="md-block without-line" md-no-float>
                                                                <md-input v-model="contact.title" placeholder="Position *" @blur="contactTouchHanlder(index, 'title')"></md-input>
                                                            </md-field>
                                                            <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.title']"><span>{{ validationErrors['newContacts.' + index + '.title'][0] }}</span></div>
                                                        </div>
                                                        <div class="primary-contact">
                                                            <md-checkbox v-if="hasMultipleContacts" v-model="contact.isPrimaryContact" aria-label="Primary Contact" @change="setPrimaryContact(index)">
                                                                Primary Contact
                                                            </md-checkbox>
                                                            <md-checkbox v-else disabled v-model="contact.isPrimaryContact" aria-label="Primary Contact" @change="setPrimaryContact(index)">
                                                                Primary Contact
                                                            </md-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-5">
                                                    <div class="line-item">
                                                        <md-field class="md-block">
                                                            <md-input v-model="contact.firstName" placeholder="First Name *" @blur="contactTouchHanlder(index, 'firstName')"></md-input>
                                                        </md-field>
                                                        <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.firstName']"><span>{{ validationErrors['newContacts.' + index + '.firstName'][0] }}</span></div>
                                                    </div>
                                                    <div class="line-item">
                                                        <md-field class="md-block">
                                                            <md-input v-model="contact.lastName" placeholder="Last Name *" @blur="contactTouchHanlder(index, 'lastName')"></md-input>
                                                        </md-field>
                                                        <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.lastName']"><span>{{ validationErrors['newContacts.' + index + '.lastName'][0] }}</span></div>
                                                    </div>
                                                    <div class="line-item">
                                                        <md-field class="md-block">
                                                            <md-input v-model="contact.directPhone" placeholder="Direct # *" @blur="contactTouchHanlder(index, 'directPhone')"></md-input>
                                                        </md-field>
                                                        <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.directPhone']"><span>{{ validationErrors['newContacts.' + index + '.directPhone'][0] }}</span></div>
                                                    </div>
                                                    <div class="line-item">
                                                        <md-field class="md-block">
                                                            <md-input v-model="contact.officePhone" placeholder="Office # "></md-input>
                                                        </md-field>
                                                        <div class="new-client-error" v-if="validationErrors['newContacts.' + index + '.officePhone']"><span>{{ validationErrors['newContacts.' + index + '.officePhone'][0] }}</span></div>
                                                    </div>
                                                </div>
                                                <md-button v-if="hasMultipleContacts" aria-label="Delete Contact" @click="deleteContact(index)">
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                                <md-button v-else aria-label="Delete Contact" class="md-icon-button" @click="deleteContacts(index)">
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="add-button PARNET " v-if="buttonVisibleParent">
                    <md-button class="md-icon-button md-primary" aria-label="Add User" @click="addContactParent()">
                        <md-icon>add</md-icon>
                    </md-button>
                </div>
                <div class="add-button child" v-if="checkChild">
                    <md-button class="md-icon-button md-primary" aria-label="Add User" @click="addContact()">
                        <md-icon>add</md-icon>
                    </md-button>
                </div>
                <div v-if="!this.checkChild && !this.contactFormError" class="bottom-btn-position">
                    <br>
                    <br>
                    <div class="wrap" v-if="recordUpdateSuccs">
                        <p v-if="recordUpdateSuccs" class="recordalert">Record Added successfully!</p>
                    </div>
                    <div class="wrap" v-if="!recordUpdateSuccs">
                        <md-button class="save-client-button md-primary" aria-label="Add New User" @click="clickSaveNewClient()">Save</md-button>
                    </div>
                </div>
                <div v-if="this.checkChild" class="bottom-btn-position">
                    <br>
                    <br>
                    <div class="wrap" v-if="recordUpdateSuccs">
                        <p v-if="recordUpdateSuccs" class="recordalert">Record Added successfully!</p>
                    </div>
                    <div class="wrap" v-if="!recordUpdateSuccs">
                        <md-button class="save-client-button md-primary" style="margin-left: 55px;position: absolute;right: 10%; bottom: 0px;" aria-label="Add New User" @click="clickSaveNewClientAndContact()">Save</md-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {required, email, url} from 'vuelidate/lib/validators';
import {saveNewClient, saveNewClientContact} from '../../services/ClientService.js';
import {notWhitespace, validPhoneNumber, validPostalOrZip, validateEmailContact} from '../../includes/validations.js';

function uniqueClientName (value) {
  let clients = this.$store.getters['client/clientList'];
  let unique = true;
  if (value) {
    for (let client of clients) {
      if (client.companyName.toLowerCase() === value.toLowerCase()) {
        unique = false;
      }
    }
  }
  return unique;
}

function uniqueEmail (value) {
  let contacts = this.newClientContacts;
  let matches = 0;
  for (let contact of contacts) {
    if (contact.email) {
      if (contact.email.toLowerCase() === value.toLowerCase()) {
        matches = matches + 1;
      }
    }
  }
  return matches <= 1;
}

export default {
  data: () => ({
    recordUpdateSucc: false,
    recordUpdateSuccs: false,
    detailsAreVisible: false,
    detailsAreVisibleChild: false,
    buttonVisibleParent: true,
    checkChild: false,
    showContact: false,
    forParentDelet: true,
    clientPhoneNumeberCheck: false,
    dataChek: 0,
    newClient: {
      companyName: null,
      phoneNumber: null,
      website: null,
      country: null,
      stateProvince: null,
      address: null,
      description: null,
      zipPostalCode: null,
      isAnalytics: false
    },
    newClientContacts: [
      {
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isPrimaryContact: true
      }
    ],
    contactFormError: null,
    validationErrors: []
  }),
  computed: {
    hasMultipleContacts () {
      return this.newClientContacts.length > 1;
    }
  },
  methods: {
    acceptNumber () {
      var x = this.newClient.phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClient.phoneNumber = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
      this.clientPhoneNumeberCheck = true;
    },
    acceptNumberContactOfficePhone (indexs) {
      let x = this.newClientContacts[indexs].officePhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClientContacts[indexs].officePhone = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
    },
    acceptNumberContactDirPhone (indexs) {
      let x = this.newClientContacts[indexs].directPhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClientContacts[indexs].directPhone = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
    },
    clientTouchHanlder (key) {
      if (key === 'phoneNumber') {

      }
      if (!this.$v.newClient[key].$dirty) {
        this.$v.newClient[key].$touch();
      }
    },
    contactTouchHanlder (index, key) {
      if (!this.$v.newClientContacts.$each[index][key].$dirty) {
        this.$v.newClientContacts.$each[index][key].$touch();
      }
    },
    async clickSaveNewClient () {
      /* if (!this.newClient.companyName) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            }
            if (!this.newClient.phoneNumber) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            }
            if (!this.newClient.address) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            } else if (this.newClient.phoneNumber) {
              setTimeout(() => {
                this.recordUpdateSuccs = true;
              }, 3000);
              await saveNewClient(this.newClient)
                .then(response => {
                  this.recordUpdateSuccs = true;
                  setTimeout(() => {
                    this.$router.push('/client/list');
                  }, 5000);
                  // this.$router.push('/client/list');
                })
                .catch(error => {
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    this.contactFormError = error.response.data.message;
                  }
                });
            }
            return false; */
      this.validationErrors = [];
      await saveNewClient(this.newClient)
        .then(response => {
          this.recordUpdateSuccs = true;
          setTimeout(() => {
            this.$router.push('/client/list');
          }, 5000);
        })
        .catch(error => {
          console.log(error.response.data);
          if (error.response.data.type === 'DUPLICATE_EMAIL') {
            this.contactFormError = error.response.data.message;
          }
          this.validationErrors = error.response.data.errors;
        });
    },
    async clickSaveNewClientAndContact () {
      /* function validateEmail (email) {
              const re = /\S+@\S+\.\S+/;
              return re.test(email);
            } */

      /* if (!this.newClient.companyName) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            }
            if (!this.newClient.address) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            }
            if (!this.newClient.phoneNumber) {
              this.recordUpdateSucc = true;
              setTimeout(() => {
                this.recordUpdateSucc = false;
              }, 3000);
            }
            for (var i = 0; i < this.newClientContacts.length; i++) {
              if (!this.newClientContacts[i].email) {
                if (!validateEmail(this.newClientContacts[i].email)) {
                  return false;
                }
                this.recordUpdateSucc = true;
                setTimeout(() => {
                  this.recordUpdateSucc = false;
                }, 3000);
              } else if (!this.newClientContacts[i].title) {
                this.recordUpdateSucc = true;
                setTimeout(() => {
                  this.recordUpdateSucc = false;
                }, 3000);
              } else if (!this.newClientContacts[i].firstName) {
                this.recordUpdateSucc = true;
                setTimeout(() => {
                  this.recordUpdateSucc = false;
                }, 3000);
              } else if (!this.newClientContacts[i].lastName) {
                this.recordUpdateSucc = true;
                setTimeout(() => {
                  this.recordUpdateSucc = false;
                }, 3000);
              } else if (!this.newClientContacts[i].directPhone) {
                this.recordUpdateSucc = true;
                setTimeout(() => {
                  this.recordUpdateSucc = false;
                }, 3000);
              } else if (this.newClientContacts[i].directPhone) {
                if (isNaN(this.newClientContacts[i].directPhone)) {
                  console.log(this.newClientContacts[i].directPhone + 'not a number');
                } else { */
      this.validationErrors = [];
      await saveNewClientContact(this.newClient, this.newClientContacts)
        .then(response => {
          this.recordUpdateSuccs = true;
          setTimeout(() => {
            this.$router.push('/client/list');
          }, 5000);
        }).catch(error => {
          if (error.response.data.type === 'DUPLICATE_EMAIL') {
            this.contactFormError = error.response.data.message;
          }
          this.validationErrors = error.response.data.errors;
        });
      /* }
              }
            } */
    },
    addContactParent () {
      this.detailsAreVisible = true;
      this.buttonVisibleParent = false;
      this.checkChild = true;
    },
    addContact () {
      this.detailsAreVisible = true;
      this.newClientContacts.push({
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isPrimaryContact: false
      });
    },
    deleteContact (index) {
      let validationErrors = this.validationErrors;

      if (validationErrors['newContacts.' + (index) + '.firstName']) {
        delete validationErrors['newContacts.' + (index) + '.firstName'];
        delete validationErrors['newContacts.' + (index) + '.lastName'];
        delete validationErrors['newContacts.' + (index) + '.email'];
        delete validationErrors['newContacts.' + (index) + '.directPhone'];
        delete validationErrors['newContacts.' + (index) + '.title'];
      }

      this.validationErrors = validationErrors;

      if (this.newClientContacts[index].isPrimaryContact) {
        if (index === 0) {
          this.newClientContacts[1].isPrimaryContact = true;
        } else {
          this.newClientContacts[0].isPrimaryContact = false;
        }
      }
      this.newClientContacts.splice(index, 1);
    },
    deleteContacts (index) {
      this.forParentDelet = false;
      this.newClientContacts[0].firstName = null;
      this.newClientContacts[0].lastName = null;
      this.newClientContacts[0].title = null;
      this.newClientContacts[0].email = null;
      this.newClientContacts[0].officePhone = null;
      this.newClientContacts[0].directPhone = null;
      this.detailsAreVisible = false;
      this.buttonVisibleParent = true;
      this.checkChild = false;
      this.validationErrors = [];
    },
    setPrimaryContact (primaryIndex) {
      for (const [index, contact] of this.newClientContacts.entries()) {
        if (index === primaryIndex) {
          contact.isPrimaryContact = true;
        } else {
          contact.isPrimaryContact = false;
        }
      }
    }
  },
  validations: {
    newClient: {
      companyName: {
        required,
        notWhitespace,
        uniqueClientName
      },
      phoneNumber: {
        required,
        notWhitespace,
        validPhoneNumber
      },
      address: {
        required,
        notWhitespace
      },
      zipPostalCode: {
        validPostalOrZip
      },
      website: {
        url
      }
    },
    newClientContacts: {
      $each: {
        firstName: {
          required,
          notWhitespace
        },
        lastName: {
          required,
          notWhitespace
        },
        title: {
          required,
          notWhitespace
        },
        email: {
          required,
          email,
          validateEmailContact,
          uniqueEmail
        },
        directPhone: {
          required,
          notWhitespace,
          validPhoneNumber
        },
        officePhone: {
          notWhitespace,
          validPhoneNumber
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.save-client-button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;

    button {
        z-index: 15;
    }
}

.new-client-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.form-error {
    font-size: 15px;
    color: red;
}

#new-client textarea {
    resize: none;
    height: 108px !important;
    min-height: 108px !important;
}

.add-button button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500 !important;
}

.add-button button:hover {
    background-color: #00788A !important;
}

.client-name-box {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.recordalert {
    position: absolute;
    float: right;
    right: 120px;
    bottom: 100px;
    color: green;

}
</style>



// WEBPACK FOOTER //
// src/components/client/NewClient.vue